var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "firstLogin" }, [
    _c(
      "div",
      {
        staticClass:
          "login-cntr d-flex align-items-center justify-center flex-wrap",
      },
      [
        _c(
          "div",
          {
            staticClass: "m-auto login-box d-flex align-items-center flex-wrap",
          },
          [
            _c("div", { staticClass: "align-items-center d-flex flex-wrap" }, [
              _c("div", { staticClass: "m-0 row justify-content-center" }, [
                _c("div", { staticClass: "container" }, [
                  _c("h1", { staticClass: "text-center" }, [
                    _vm._v(_vm._s(_vm.$t("lang.content.new_password"))),
                  ]),
                  _c("p", { staticClass: "text-center" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("lang.content.change_firstPassword")) +
                        " "
                    ),
                  ]),
                ]),
                _c("div", [
                  _c(
                    "form",
                    {
                      attrs: { novalidate: "" },
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.onSubmit.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _vm.msjErrorlogin.length != 0
                        ? _c("b-form-invalid-feedback", [
                            _vm._v(_vm._s(_vm.msjErrorlogin)),
                          ])
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticClass: "form-group",
                          class: {
                            "form-group--error": _vm.oldPasswordError.show,
                          },
                        },
                        [
                          _c("label", [
                            _vm._v(_vm._s(_vm.$t("lang.content.oldPassword"))),
                          ]),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.lazy",
                                value: _vm.oldPassword,
                                expression: "oldPassword",
                                modifiers: { lazy: true },
                              },
                            ],
                            staticClass: "form-control form-control__password",
                            attrs: {
                              type: "password",
                              placeholder: _vm.$t(
                                "lang.content.enter_Password"
                              ),
                            },
                            domProps: { value: _vm.oldPassword },
                            on: {
                              change: function ($event) {
                                _vm.oldPassword = $event.target.value
                              },
                            },
                          }),
                          _vm.oldPasswordError.show
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm.oldPasswordError.type == "wrong"
                                  ? _c("div", { staticClass: "error" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "lang.content.password_wrong"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm.oldPasswordError.type == "required"
                                  ? _c("div", { staticClass: "error" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "lang.content.password_required"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "form-group",
                          class: {
                            "form-group--error": _vm.passwordError.show,
                          },
                        },
                        [
                          _c("label", [
                            _vm._v(_vm._s(_vm.$t("lang.content.new_password"))),
                          ]),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.lazy",
                                value: _vm.password,
                                expression: "password",
                                modifiers: { lazy: true },
                              },
                            ],
                            staticClass: "form-control form-control__password",
                            attrs: {
                              type: "password",
                              placeholder: _vm.$t(
                                "lang.content.type_newPassword"
                              ),
                            },
                            domProps: { value: _vm.password },
                            on: {
                              change: function ($event) {
                                _vm.password = $event.target.value
                              },
                            },
                          }),
                          _vm.passwordError.show
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm.passwordError.type == "required"
                                  ? _c("div", { staticClass: "error" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "lang.content.password_required"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm.passwordError.type == "wrong"
                                  ? _c("div", { staticClass: "error" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "lang.content.password_required"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "form-group",
                          class: {
                            "form-group--error": _vm.confirmPasswordError.show,
                          },
                        },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.$t("lang.content.repeat_password"))
                            ),
                          ]),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.lazy",
                                value: _vm.confirmPassword,
                                expression: "confirmPassword",
                                modifiers: { lazy: true },
                              },
                            ],
                            staticClass: "form-control form-control__password",
                            attrs: {
                              type: "password",
                              placeholder: _vm.$t(
                                "lang.content.repeat_password"
                              ),
                            },
                            domProps: { value: _vm.confirmPassword },
                            on: {
                              change: function ($event) {
                                _vm.confirmPassword = $event.target.value
                              },
                            },
                          }),
                          _vm.confirmPasswordError.show
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm.confirmPasswordError.type == "required"
                                  ? _c("div", { staticClass: "error" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "lang.content.password_required"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm.confirmPasswordError.type == "wrong"
                                  ? _c("div", { staticClass: "error" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("lang.content.long_password")
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex flex-wrap justify-content-lg-end align-items-center btn-wrap pt-md-4 pt-2",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-info",
                              attrs: { type: "submit" },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("lang.buttons.send")) + " "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }